import * as Yup from "yup";
import { hasMaxAge, hasMinAge, isValidDateInput } from "../components/utils";

export const personalInfoSchema = (isSmsDubsscription = false) => Yup.object().shape({
  first_name: Yup.string()
    .required("First name is required")
    .matches(
      /^[a-zA-Z ]*$/,
      "First name should not contain special characters or numbers"
    )
    .max(50, "First name should not contain more than 50 characters"),
  last_name: Yup.string()
    .required("Last name is required")
    .matches(
      /^[a-zA-Z ]*$/,
      "Last name should not contain special characters or numbers"
    ),
  email: Yup.string()
    .email("Enter a valid email")
    .required("Email address is required"),
  phone: isSmsDubsscription ? 
  Yup.string()
    .required("Phone number is required")
    .transform((value) => value.replace(/[^\d]/g, ""))
    .length(10, "Phone number must be 10 digits long") :
    Yup.string()
    .nullable()
    .transform((value) => value.replace(/[^\d]/g, ""))
    .length(10, "Phone number must be 10 digits long")  ,
  favorite_location: Yup.array().nullable(),
  birthday: Yup.string()
    .optional()
    .test("min-age", "You must be at least 13 years old", (date) =>
      hasMinAge(date, 13)
    )
    .test("max-age", "Age cannot be greater than 149 years", (date) =>
      hasMaxAge(date, 149)
    )    .test("valid-date", "Please enter a valid Birthdate (MM/DD/YYYY)", (date) =>
      isValidDateInput(date)
    ),
});